import {portalApiPost} from '@/lib/portal-api';
import {moneyOperationSession} from './money-operation-session';
import {readCloseCheck,type CloseCheck} from './close-recovery';
export interface SavedReview {clinicId:number;checkId:string;decision:'confirm'|'send_back';note:string;requestId:string}
function read(key:string):SavedReview|null {
 const raw=sessionStorage.getItem(key);if(raw===null)return null;
 const x=JSON.parse(raw) as SavedReview;
 if(!Number.isSafeInteger(x?.clinicId)||x.clinicId<=0||!x.checkId||!['confirm','send_back'].includes(x.decision)||typeof x.note!=='string'||x.note.length>1000||!/^[-a-f0-9]{36}$/.test(x.requestId))throw new Error('The saved review could not be read. Keep this session for recovery.');
 return x;
}
function bound(x:SavedReview|null,clinicId:number,checkId:string) {
 if(x&&(x.clinicId!==clinicId||x.checkId!==checkId))throw new Error('Resolve the saved review in its original clinic and count first.');
 return x;
}
export async function pendingReview(clinicId:number,checkId:string) {
 const s=await moneyOperationSession('close-review');const x=bound(read(s.key),clinicId,checkId);await s.assertCurrent();return x;
}
function matches(check:CloseCheck,x:SavedReview) {
 const r=check.review;
 return check.checkId===x.checkId&&r?.request_id===x.requestId&&r.check_id===x.checkId&&r.clinic_id===x.clinicId&&r.decision===x.decision&&(r.note??'')===x.note&&!!r.reviewed_at&&
  (x.decision==='confirm'?check.confirmed&&!!check.confirmedAt:check.sentBack===true);
}
/** A scoped read may prove a lost response committed, or that this count can no longer be reviewed. */
export async function recoverReview(clinicId:number,checkId:string) {
 const s=await moneyOperationSession('close-review');const x=bound(read(s.key),clinicId,checkId);
 const check=await readCloseCheck(clinicId,checkId);await s.assertCurrent();
 if(x&&(matches(check,x)||check.sourceChanged||check.closed||check.confirmed||check.sentBack)) {
  // Read-only retirement: a terminal count must never offer a new review write.
  if(sessionStorage.getItem(s.key)===JSON.stringify(x))sessionStorage.removeItem(s.key);
  return {check,pending:null};
 }
 return {check,pending:x};
}
export async function submitReview(clinicId:number,checkId:string,decision:SavedReview['decision'],noteRaw:string) {
 const note=noteRaw.trim();if(note.length>1000||(decision==='send_back'&&!note))throw new Error('Give a reason before sending back.');
 const s=await moneyOperationSession('close-review');let x=bound(read(s.key),clinicId,checkId);
 if(x&&(x.decision!==decision||x.note!==note))throw new Error('Resolve the saved review before changing it.');
 if(!x){x={clinicId,checkId,decision,note,requestId:crypto.randomUUID()};sessionStorage.setItem(s.key,JSON.stringify(x));if(JSON.stringify(read(s.key))!==JSON.stringify(x))throw new Error('Recovery could not be saved. Nothing was sent.');}
 await s.assertCurrent();
 const out=await portalApiPost<{check:CloseCheck}>(`/accounts/day/check/${decision==='confirm'?'confirm':'send-back'}`,x,s.bearer);
 await s.assertCurrent();
 if(!out?.check||!matches(out.check,x))throw new Error('The review could not be verified. Check the saved review before retrying.');
 if(sessionStorage.getItem(s.key)===JSON.stringify(x))sessionStorage.removeItem(s.key);
 return out.check;
}
